import { z } from 'zod';
// Shared between backend controller DTOs and any future frontend audit viewer
// (JQ4-41 / US-AUDIT-001). Mirrors zone-schemas.ts conventions.
// ─────────────────────────────────────────────────────────────────────────────
// Event-category enum + prefix map (JQ4-45 ADR-1)
// ─────────────────────────────────────────────────────────────────────────────
export const AUDIT_CATEGORY = z.enum(['authentication', 'ticket', 'payment', 'configuration']);
/**
 * Maps each category to the stored action prefix used for startsWith queries.
 * Single source of truth shared between the use case and the frontend.
 */
export const AUDIT_CATEGORY_PREFIXES = {
    authentication: 'auth.',
    ticket: 'ticket.',
    payment: 'payment.',
    configuration: 'config.',
};
export const ListAuditLogQuerySchema = z
    .object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    action: z.string().max(120).optional(),
    resourceId: z.string().max(200).optional(),
    /** Event-category filter (JQ4-45). Mutually exclusive with action (exact wins). */
    category: AUDIT_CATEGORY.optional(),
    /** Filter by actor user ID (JQ4-45). Must be a valid UUID. */
    actorUserId: z.string().uuid().optional(),
})
    .refine((v) => !v.from || !v.to || new Date(v.from) <= new Date(v.to), {
    message: "'to' must not precede 'from'",
    path: ['to'],
});
export const AuditLogEntryResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid().nullable(),
    actorUserId: z.string().uuid().nullable(),
    // Human-readable actor identity resolved at read time from identity_users.
    // Null when the entry has no actor (system action) or the actor can no longer
    // be resolved (deleted user) — the UI falls back to a short actorUserId then.
    actorEmail: z.string().nullable(),
    actorRole: z.string().nullable(),
    action: z.string(),
    resourceType: z.string(),
    resourceId: z.string().nullable(),
    metadata: z.record(z.unknown()),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    createdAt: z.string(), // ISO 8601 UTC
});
export const ListAuditLogResponseSchema = z.object({
    items: z.array(AuditLogEntryResponseSchema),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
});
//# sourceMappingURL=audit-schemas.js.map